/* eslint-disable */
import React from 'react';
import { Spinner } from 'react-bootstrap';

const Loader = () => {
	return (
		<div className='fixed-spinnerr'>
			<Spinner
			as='span'
			role='status'
			aria-hidden='true'
			animation='border'
		/>
		</div>
	);
};

export default Loader;
